import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Fuel, ClipboardList, ArrowRight, ShieldCheck } from "lucide-react";

const TILES = [
  {
    to: "/check-in",
    testid: "tile-checkin",
    title: "Check-in cantiere",
    desc: "Conferma presenze e attrezzature, fotografa lo stato dei mezzi appena arrivi.",
    icon: ShieldCheck,
    accent: "from-amber-500 to-orange-500",
    operatorOnly: true,
  },
  {
    to: "/carburante",
    testid: "tile-carburante",
    title: "Richiesta carburante",
    desc: "Richiedi e autorizza i rifornimenti della flotta.",
    icon: Fuel,
    accent: "from-[#002FA7] to-[#0043e0]",
  },
  {
    to: "/rapportini-home",
    testid: "tile-rapportini",
    title: "Rapportini di lavoro",
    desc: "Compila i rapportini di cantiere e monitora ricavi, costi e margini.",
    icon: ClipboardList,
    accent: "from-emerald-600 to-emerald-500",
  },
];

export default function Home() {
  const { user } = useAuth();
  const isOperator = user?.role === "utilizzatore";
  const tiles = TILES.filter((t) => !t.operatorOnly || isOperator).map((t) =>
    t.to === "/rapportini-home"
      ? { ...t, to: isOperator ? "/miei-rapportini" : "/rapportini" }
      : t.to === "/carburante"
      ? { ...t, to: "/carburante" }
      : t
  );

  return (
    <div className="mx-auto max-w-5xl">
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900">
          Ciao, {user?.name?.split(" ")[0]} 👋
        </h1>
        <p className="mt-1 text-sm text-slate-500">Scegli il modulo con cui vuoi lavorare.</p>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-testid="home-tiles">
        {tiles.map((t) => (
          <Link
            key={t.testid}
            to={t.to}
            data-testid={t.testid}
            className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-7 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-lg"
          >
            <div className={`inline-flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-to-br ${t.accent} text-white`}>
              <t.icon className="h-7 w-7" />
            </div>
            <h2 className="mt-5 font-heading text-xl font-bold text-slate-900">{t.title}</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-500">{t.desc}</p>
            <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#002FA7]">
              Apri modulo <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
